import React, { useState, useEffect } from "react";
import { useProductStore } from "src/hooks/product";
import AxiosIndicatorRunTimeLoader from "src/component/Global/AxiosIndicatorRunTimeLoader";
import { __set, } from "src/store/axios_indicator";
import System from "src/helper/system";
import TopProductDetail from "../ProductDetail/ProductDetailLeftContent/TopProductDetail/TopProductDetail";
import ProductDetailTabs from "../ProductDetail/ProductDetailLeftContent/ProductDetailTabs/ProductDetailTabs";
import ProductDetailBuyBox from "../ProductDetail/ProductDetailRightContent/ProductDetailBuyBox";
import ProductDetailAd from "../ProductDetail/ProductDetailRightContent/ProductDetailAd";
import Helper from "../../helper/Helper";
import { Tooltip } from "../../component/Global/Tooltip";
import $ from "jquery";
import { ProductDetailEsop } from "../ProductDetail/ProductDetailRightContent/ProductDetailEsop";
import Constants from "src/helper/Constants";
import RefreshStockButton from "../ProductListing/RefreshStockButton";
import ShowAlert from "src/component/Global/ShowAlert";

export function ProductDetail() {

  let c = System.getParams();
  const [{ productList }, { get_product_assets, get_product_detail }, { }] = useProductStore();
  const [loader, setLoader] = useState(true)
  const url = window.location.href?.split('?')[0];
  const urlAry = url?.split('/').filter(data => data.length > 0);
  const ItemNumber = Helper.toUpperCase(urlAry[urlAry.length - 1]);
  const [parentClass, setParentClass] = useState('');
  const [monitorFunctionCall, setMonitorFunctionCall] = useState({
      monitorJs: false,
      frameworkReady: false
    });
  const { Distributor } = Constants

  useEffect(() => {
    async function fetchHere() {
      await fetchProductDetailFromServer();
    }
    __set('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')
    fetchHere();
  }, [ItemNumber]);

  const fetchProductDetailFromServer = async () => {
    __set('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')

    if (ItemNumber) {
      const res = await get_product_detail([{ ItemNumber: ItemNumber }], true)
      if (res) {
        if (!monitorFunctionCall?.frameworkReady) {
          System.monitorFrameWorkReady()
          setMonitorFunctionCall({...monitorFunctionCall, frameworkReady: true})
        }
      }
      setLoader(false)
    }
  };

  useEffect(() => {
    async function fetchHere() {
      if (productList && productList[ItemNumber] && Object.keys(productList[ItemNumber]).length > 0) {
        let topProducts = []
        topProducts = [...productList[ItemNumber].TopProducts]
        topProducts = topProducts.map(v => ({
          ...v,
          exists_in_sap: v.exists_in_sap ? true : false,
          factory_qoh: v.factory_qoh ? parseInt(v.factory_qoh) : 0,
          distributor: v.distributor ? v.distributor : Distributor.AVNET,
          isAvnetDistributor: v.distributor === Distributor.AVNET ? true : false,
          isPartnerDistributor: v.distributor === Distributor.FLIP || v.distributor === Distributor.ROCHESTER || v.distributor === Distributor.WALDOM ? true : false,
          isNewarkDistributor: v.distributor === Distributor.NEWARK ? true : false,
          default_plant: v.default_plant ? v.default_plant : "",
          MDMMaterialID: v.MDMMaterialID ? v.MDMMaterialID : ""
        }));

        let product = { ...productList[ItemNumber] };
        if (c.searchTerm) {
          const searchedCPN = c.searchTerm;
          let cpnAvailable = System.isCPNAvailableInList(product, searchedCPN)
          if (cpnAvailable) {
            product.CPN = searchedCPN

          }
        }

        topProducts.push(product);
        await get_product_assets(topProducts)
        if (!monitorFunctionCall?.monitorJs) {
          System.monitorJSDx()
          setMonitorFunctionCall({...monitorFunctionCall, monitorJs: true})
        }
      }
    }
    fetchHere()

  }, [productList])

  const renderTooltip = (props) => (
    <>
      <RefreshStockButton label={'Refresh Stock'} />
      <br />
      Refresh the product availability to a real time call.
    </>
  );

  useEffect(() => {
    Helper.feedBackButtonScript()
  }, []);

  return (
    <>
      <div className="logged-screen">
        <>
          <ShowAlert doNotShow={['productDetailsErr','productCompare']} />
          {loader ?
            <>
              <AxiosIndicatorRunTimeLoader overlay={true} />
            </> :
            <>
              {productList[ItemNumber] && (
                <>
                  <ShowAlert onlyShowMessage={['productDetailsErr']} />

                  <div className="container pdp-container">
                    <div className="bs5 row pdp-row">
                      <div className="col-xl-8 col-lg-7 pdp-container-left">
                        <div className="col-12">
                          <TopProductDetail productDetail={productList[ItemNumber]} />
                          <div className="desktophide mobileshow mt-3">
                            <ProductDetailBuyBox productDetail={productList[ItemNumber]} />
                          </div>
                          <ProductDetailTabs productDetail={productList[ItemNumber]} />
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-5 mt-3 mt-lg-0 pdp-container-right">
                        <div className='product-detail-right mobilehide desktopshow' style={{
                          top: $(".header").height()
                        }}>

                          <div className="icon-list icon-list-inline justify-content-around text-13 d-none d-sm-flex">
                            <Tooltip
                              opener={() => (
                                <a className="icon-list-item text-black" style={{ cursor: 'auto' }}>
                                  <i className="fa fa-info-circle" />
                                  <span className="text-blue text-nowrap">Tool Tip</span>
                                </a>
                              )}
                              content={() => (
                                renderTooltip()
                              )}
                              position={'bottom center'}
                            />
                            <a key={Helper.UUID()} onClick={() => { window.print() }} className="icon-list-item text-black">
                              <i className="fa fa-print" />
                              <span className="text-blue">Print</span>
                            </a>
                            {/* <a key={Helper.UUID()} style={{ cursor: 'pointer' }} onClick={onShare} className="icon-list-item text-black">
                            <i className="fa fa-share-alt" />
                            <span className="text-blue">Share</span>
                        </a> */}
                            {/* <a key={Helper.UUID()} style={{ cursor: 'pointer' }} onClick={() => {
                              System.popup('SendEmailOfReportError', { productDetail: productList[ItemNumber] })
                            }} className="icon-list-item text-black">
                              <i className="fa fa-unlink" />
                              <span className="text-blue">Report Error</span>
                            </a> */}
                          </div>

                          <div className={parentClass} id="stock-box-pdp">
                            <ProductDetailBuyBox setParentClass={setParentClass} productDetail={productList[ItemNumber]} />
                          </div>
                          <div className={parentClass} >
                            <ProductDetailEsop />
                          </div>
                        </div>
                        <div className='mobileads mt-3'>
                          <ProductDetailAd />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          }
        </>
      </div>
    </>
  );
}
